import { FC, useContext, useEffect } from "react"

import useFetch from "src/hooks/useFetch";
import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { downloadExcelFile } from "src/helpers/downloadFile";

import { APIEndpoints } from "src/types/apiTypes";
import { DownloadReportsResponseTypeApi, StatsReportProps } from "./types";



const StatsReports: FC<StatsReportProps> = ({ getValues, role }): JSX.Element => {
  const { userData } = useContext(AuthContext)
  const { setLoader, hideLoader } = useContext(LoaderContext);



  const {
    loading: downloadReportsLoading,
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm,
    removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadReportsResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      if (downloadReportsData) {
        const { response, report_name } = downloadReportsData;
        downloadExcelFile(response, `${report_name}.xlsx`);
      }

      hideLoader()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);

  const downloadReport = (reportName: string) => {
    if (getValues) {
      let params = {
        'start_date': getValues().start_date,
        'end_date': getValues().end_date,
        'report_name': reportName,
        role: role,
        user_id: getValues().user_id || (userData ? userData.id.toString() : ""),
      }
      if (downloadReportsData || downloadReportsError) clearRequestFileData();

      setLoader();
      downloadRequestForm({}, {}, params);
    }
  }



  return (
    <div className="row g-2">
      {downloadReportsLoading ? (
        <p className="text-dark h5">
          <span className="spinner-border spinner-border-sm" style={{ width: 20, height: 20 }} aria-hidden="true"></span>{' '}
          <i>Fetching Report</i>
        </p>
      ) : userData?.ref_type === "Manufacturer" ? (
        <>
          <div className="col">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("detail_report")}
            >
              Detail Report
            </button>
          </div>

          <div className="col">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("full_report")}
            >
              Full Report
            </button>
          </div>

          <div className="col">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("plan_report")}
            >
              Plan Report
            </button>
          </div>

          <div className="col-12 col-sm-3">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("pa_report")}
            >
              PA Report
            </button>
          </div>

          <div className="col">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("transfer_report")}
            >
              Transfer Report
            </button>
          </div>
        </>
      ) : (
        <> 
          <div className="col-12 col-sm-4">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("detail_report")}
            >
              Detail Report
            </button>
          </div>

          <div className="col-12 col-sm-4">
            <button
              className="btn btn-success w-100"
              onClick={() => downloadReport("full_report")}
            >
              Full Report
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default StatsReports;
